import { ALL_MODIFIERS } from "@animus/habit-modules/nutrition";

import { AdminModifiers } from "./admin-modifiers.tsx";

function AdminModifiersConnected() {
  return <AdminModifiers modifiers={ALL_MODIFIERS} />;
}

export { AdminModifiersConnected };
